import React from 'react';
import styled from 'styled-components';
import './loader.css';

const LoaderContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 100px auto;
`;

export default () => (
  <LoaderContainer>
    <div className="windows8">
      <div className="wBall" id="wBall_1">
        <div className="wInnerBall" />
      </div>
      <div className="wBall" id="wBall_2">
        <div className="wInnerBall" />
      </div>
      <div className="wBall" id="wBall_3">
        <div className="wInnerBall" />
      </div>
      <div className="wBall" id="wBall_4">
        <div className="wInnerBall" />
      </div>
      <div className="wBall" id="wBall_5">
        <div className="wInnerBall" />
      </div>
    </div>
  </LoaderContainer>
);



// WEBPACK FOOTER //
// ./src/components/Loader.js